import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * @class Contracts
 * @private
 */
export var Contracts = /*#__PURE__*/function () {
  function Contracts() {
    _classCallCheck(this, Contracts);
  }

  _createClass(Contracts, null, [{
    key: "throwIfNullOrUndefined",
    value: function throwIfNullOrUndefined(param, name) {
      if (param === undefined || param === null) {
        throw new Error("throwIfNullOrUndefined:" + name);
      }
    }
  }, {
    key: "throwIfNull",
    value: function throwIfNull(param, name) {
      if (param === null) {
        throw new Error("throwIfNull:" + name);
      }
    }
  }, {
    key: "throwIfNullOrWhitespace",
    value: function throwIfNullOrWhitespace(param, name) {
      Contracts.throwIfNullOrUndefined(param, name);

      if (("" + param).trim().length < 1) {
        throw new Error("throwIfNullOrWhitespace:" + name);
      }
    }
  }, {
    key: "throwIfDisposed",
    value: function throwIfDisposed(isDisposed) {
      if (isDisposed) {
        throw new Error("the object is already disposed");
      }
    }
  }, {
    key: "throwIfArrayEmptyOrWhitespace",
    value: function throwIfArrayEmptyOrWhitespace(array, name) {
      Contracts.throwIfNullOrUndefined(array, name);

      if (array.length === 0) {
        throw new Error("throwIfArrayEmptyOrWhitespace:" + name);
      }

      var _iterator = _createForOfIteratorHelper(array),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          Contracts.throwIfNullOrWhitespace(item, name);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "throwIfFileDoesNotExist",
    value: function throwIfFileDoesNotExist(param, name) {
      Contracts.throwIfNullOrWhitespace(param, name); // TODO check for file existence.
    }
  }]);

  return Contracts;
}();